// John Eldhose 20180511
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, CircularProgress, Divider, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { Business, Contacts, Create, Email, LocalPostOffice, LocationCity, LocationOn, Phone, QuestionAnswer, Settings, Title, Work } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { emailValid } from './lib/lib';
import { setLoginPage } from './lib/LoginPage';
import countries from './lib/countries';
import industries from './lib/industries';
import ShowStatus from './lib/ShowStatus';
import { contactSales } from '../Api/contactSales';

class TeaserContact extends Component {

  state = {
    Question: '',
    Industry: '',
    JobTitle: '',
    ContactPreference: '',
    CompanyDescription: '',
    FirstName: '',
    LastName: '',
    email: '',
    phone: '',
    ADDRESS1: '',
    CITY: '',
    STATE: '',
    POSTALCODE: '',
    COUNTRY: '',
    pageStatus: 0
  }
  handleSignIn = () => {
    setLoginPage({ url: '/contact' });
    window.location = '/login';
  }
  handleUserInput = (event, lower = false) => {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
  }
  disableContact = () => {
    var s = this.state;
    return (
      s.Question === '' || s.CompanyDescription === '' || s.FirstName === '' ||
      s.LastName === '' || emailValid(s.email) === false || s.STATE === '' ||
      s.COUNTRY === '' || (s.COUNTRY === 'United States' && s.POSTALCODE === '')
    );
  }
  handleContact = () => {
    this.setState({ pageStatus: 1 });
    var s = this.state;
    var data = {
      Question: s.Question, Industry: s.Industry, JobTitle: s.JobTitle, ContactPreference: s.ContactPreference,
      CompanyDescription: s.CompanyDescription, FirstName: s.FirstName, LastName: s.LastName, email: s.email, phone: s.phone,
      ADDRESS1: s.ADDRESS1, CITY: s.CITY, STATE: s.STATE, POSTALCODE: s.POSTALCODE, COUNTRY: s.COUNTRY
    };
    contactSales(data)
      .then((con) => {
        this.setState({
          pageStatus: ((con['status'] === 'true') ? con['send'] : 2)
        });
      })
      .catch((err) => { console.log(err); })
  }

  render() {
    if (this.state.pageStatus === 1)
      return <CircularProgress />;
    else if(this.state.pageStatus === 2)
      return <ShowStatus status='failed' />;
    else if(this.state.pageStatus === 3)
      return <ShowStatus status='thankyou' />;
    else
      return (
        <div>
          <Typography variant='display1'>
            <font color='#385687'>Contact Sales</font>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button
                fullWidth
                variant='raised'
                color='primary'
                onClick={this.handleSignIn}
              >
                Already have an account? Sign In
              </Button>
            </Grid>
          </Grid>
          <p />
          <Typography variant='title'>How can we help you?</Typography>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <QuestionAnswer className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  multiline
                  rows='3'
                  inputProps={{ maxLength: 499 }}
                  label='Request a Quote or Ask a Question'
                  name='Question'
                  value={this.state.Question}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <Typography variant='title'>Your Details</Typography>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Business className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  select
                  label='Industry'
                  name='Industry'
                  value={this.state.Industry}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  {industries.map(industry => (
                    <MenuItem key={industry} value={industry}>
                      {industry}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Title className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='Job Title'
                  name='JobTitle'
                  value={this.state.JobTitle}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Settings className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  select
                  label='Contact Preference'
                  name='ContactPreference'
                  value={this.state.ContactPreference}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  {['Email', 'Phone'].map(pref => (
                    <MenuItem key={pref} value={pref}>{pref}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Work className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  label='Company'
                  name='CompanyDescription'
                  value={this.state.CompanyDescription}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Contacts className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  label='First name'
                  name='FirstName'
                  value={this.state.FirstName}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Contacts className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  label='Last name'
                  name='LastName'
                  value={this.state.LastName}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Email className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  label='Email address'
                  name='email'
                  value={this.state.email}
                  onChange={(event) => this.handleUserInput(event, true)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Phone className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='Work Phone'
                  name='phone'
                  value={this.state.phone}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <Typography variant='title'>Your Address</Typography><br />
          <Typography>
            Please provide your location so we may connect you with the appropriate Carlson representative
          </Typography>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <LocationOn className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='Address'
                  name='ADDRESS1'
                  value={this.state.ADDRESS1}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <LocationOn className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='City'
                  name='CITY'
                  value={this.state.CITY}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <LocationOn className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  label='State'
                  name='STATE'
                  value={this.state.STATE}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <LocalPostOffice className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='Zip'
                  name='POSTALCODE'
                  value={this.state.POSTALCODE}
                  onChange={(event) => this.handleUserInput(event)}
                  helperText='Required for the US customer'
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <LocationCity className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  select
                  label='Country'
                  name='COUNTRY'
                  value={this.state.COUNTRY}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  {countries.map((country) => (
                    <MenuItem key={country} value={country}>{country}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </div>
          <p />
          <Button
            variant='raised'
            color='primary'
            fullWidth
            disabled={this.disableContact()}
            onClick={this.handleContact}
          >
            Send Message &nbsp; <Create />
          </Button>
          <p />
          <Divider />
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/' fullWidth>
                <FormattedMessage
                  id='Return to Login'
                  defaultMessage='Return to Login'
                />
              </Button>
            </Grid>
          </Grid>
        </div>
      );
  }
}

export default TeaserContact;



// WEBPACK FOOTER //
// ./src/components/TeaserContact.js